<template>
    <div class="certifi-brochure-wrap">
        <a
            class="brochure-btn"
            href="/brochure/certified-cics-cip2.pdf"
            download="한국내부통제협회 자격증 소개브로슈어.pdf"
        >
            <i class="fa-solid fa-download brochure-icon" aria-hidden="true"></i>
            Brochure 다운로드
        </a>
    </div>
    <section class="cics">
        <div class="cics__inner">
            <h2 class="cics__title">
                <strong>Certified Internal Control Professional<br />CICP 국제공인 전문내부통제사</strong>
            </h2>

            <p>
                &nbsp;CICP(Certified Internal Control Professional)는 국제내부통제협회<strong>(ICI: Internal Control
                    Institute)</strong>가 수여하는
                <strong>내부통제 분야 최고 수준의 국제공인 자격</strong>입니다.<br/>
                이 자격은 <strong>경영진, 감사(위원), 감사부서장, 내부통제부서장 등</strong> 조직의 내부통제 관리 및 평가를 총괄하는 최고위 전문가를 대상으로 합니다.<br />

                CICP는 단순한 자격 인증이 아닌, 조직의 <strong>내부통제 전략 수립, 설계, 운영, 평가 전 과정을 총괄할 수 있는 역량</strong>을 국제적으로 공식 검증받았음을
                의미합니다.<br/>
                CICS 자격을 기반으로 한 실무 경험을 확장하여, 조직의 내부통제 문화를 선도하고 글로벌 기준에 부합하는 통제 체계를 구축할 수 있는 <strong>국제적으로 인정받는 내부통제 리더의
                    표준</strong>으로
                자리매김하고 있습니다.
                CICP 보유자는 내부통제의 전문성과 신뢰성을 공식적으로 인정받으며, 조직의 투명경영과 지속가능한 내부통제 환경을 이끄는 <strong>최고위급 내부통제 전문가</strong>로
                평가받습니다.
            </p>
        </div>
    </section>

<section class="cics-feature">
  <div class="cics-feature__inner">
    <h2 class="cics-feature__title">
      <strong>CICP 자격의 특징</strong>
    </h2>

    <ul class="cics-feature__grid">
      <li class="cics-feature__item">
        <div class="cics-feature__icon">
          <i class="fa-solid fa-user-tie"></i>
        </div>
        <div class="cics-feature__text">
          <strong>최고위급 전문 자격</strong><br>
          경영진, 감사위원, 내부통제 부서장 등 조직의 통제·평가 총괄자에게 특화
        </div>
      </li>

      <li class="cics-feature__item">
        <div class="cics-feature__icon">
          <i class="fa-solid fa-globe"></i>
        </div>
        <div class="cics-feature__text">
          <strong>국제적 인증</strong><br>
          ICI가 직접 인증하고, 전 세계가 인정하는 내부통제 리더의 표준
        </div>
      </li>

      <li class="cics-feature__item">
        <div class="cics-feature__icon">
          <i class="fa-solid fa-chart-line"></i>
        </div>
        <div class="cics-feature__text">
          <strong>조직 대표 역량 강화</strong><br>
          내부통제 관리와 외부 감사 대응 능력 제고
        </div>
      </li>

      <li class="cics-feature__item">
        <div class="cics-feature__icon">
          <i class="fa-solid fa-award"></i>
        </div>
        <div class="cics-feature__text">
          <strong>회원 특전</strong><br>
          한국내부통제협회(ICIK) 회원은 교육·시험없이 서류 심사만으로 자격 심사 가능
        </div>
      </li>
    </ul>
  </div>
</section>


    <section class="cicp-stack" aria-labelledby="cicp-eng-title">
        <div class="cicp-stack__inner">
            <figure class="cicp-figure">
                <!-- <img src="@/assets/certification1.jpg" alt="CICP 인증 절차 다이어그램" loading="lazy" /> -->
                <img src="@/assets/cicp-img3.png" alt="CICP 인증 절차 다이어그램" loading="lazy" />
            </figure>
            <div class="cicp-stack-under">
                <p>CICP는 내부통제 관리(평가)책임자라면 <strong>누구보다 먼저 취득해야 할 국제적 표준 자격입니다</strong></p>
            </div>
        </div>
    </section>

    <!-- ───────── CICP 응시료 표 ───────── -->
    <!-- <section class="cicp-fee" aria-labelledby="cicp-fee-title">
        <div class="cicp-fee__inner">
            <h2 id="cicp-fee-title" class="cicp-fee__title">CICP 자격 개별 응시료</h2>

            <div class="fee-table-wrap">
                <table class="fee-table">
                    <thead>
                        <tr>
                            <th scope="col">구분</th>
                            <th scope="col">비용(VAT 포함)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="category">
                                CICP,<br />
                                <span class="en">Certified Internal Control Professional</span>
                            </td>
                            <td class="amount">1,000,000원</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <p class="fee-note">※ 행정비 및 자격 심사비 포함</p>
        </div>
    </section> -->

    <!-- section3 -->
    <div class="eligible-bg-sec3">
        <div class="eligible-container-sec3">
            <h2 class="eligible-title-sec3">
                지원 자격
            </h2>
            <div class="eligible-content-sec3">
                <div class="eligible-image2-sec3"></div>
                <div class="eligible-text-sec3">
                    <p>
                        CICP는 감사(위원), 감사·내부통제 부서장 등 조직의 내부통제 관리(평가)책임자에 내부통제 관리(평가)책임자에 특화된 자격으로 조직 내 내부통제 리더의 역량을 국제내부통제협회 ICI가 심사하여 국제적으로 인증합니다. 

                    </p>

                    <!-- <ul class="eligible-list-sec3 highlight-box">
                        <li>
                            <strong>인증 대상</strong> : 감사(위원), 감사부서장, 내부통제부서장 등 최고위 내부통제 관리(평가)책임자급
                        </li>
                        <li>
                            <strong>자격 심사</strong> : ICI 인증위원회의 자격요건 심사 후 합격자에게 자격증 발급<br />
                            <span class="note">※ ICIK 회원인 경우 교육·시험 없이 서류만으로 자격 심사 특전 제공</span>
                        </li>
                    </ul> -->

                    <div class="eligible-section">
                        <div class="eligible-req-title-sec3">자격 요건</div>
                        <p class="eligible-desc">지원자는 다음 중 하나의 최소 자격 요건을 충족해야 합니다.</p>
                        <ul class="eligible-list2-sec3">
                            <li>C학사 학위 + 8년 이상 내부통제 실무 경력</li>
                            <li>석사 학위 + 7년 이상 내부통제 실무 경력</li>
                            <li>학위 요건 없음 + 12년 이상 내부통제 실무 경력</li>
                            <li>CICS 취득자 + 8년 이상 경력</li>
                        </ul>
                    </div>

                    <div class="eligible-section">
                        <div class="eligible-req-title-sec3">추가 요건</div>
                        <p class="eligible-desc">
                           CICP 인증을 획득하려면, ICI Certification Board의 경력·역량 심사를 위해 내부통제 직무 8개 분야 중 최소 6개 이상 충족해야 합니다.
                        </p>
                        <h3 class="evaluation-title">심사항목(8개 직무 영역)</h3>
                        <ul class="eligible-list2-sec3">
                            <li>Internal Control Concepts(필수 충족 항목)</li>
                            <li>Internal Control Environment</li>
                            <li>Risk Management</li>
                            <li>Assessing Application Controls</li>
                            <li>Business System Control Assessment</li>
                            <li>Risk Assessment</li>
                            <li>Internal Control Measurement & Reporting</li>
                            <li>Governance Practices</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="fee">
        <div class="fee__head">
            <h2 class="fee__title">자격인증 비용</h2>
            <!-- <p class="fee__note">※ 행정비 및 자격 심사비 포함 (VAT포함)</p> -->
            <p class="fee__note">※ 행정비 및 자격 심사비 포함</p>
        </div>

        <!-- 표 (Grid) -->
        <div class="fee__table" role="table" aria-label="자격인증 비용 표">
            <!-- 헤더 -->
            <div class="fee__row fee__row--head" role="row">
                <div class="fee__cell" role="columnheader">자격증 비용</div>
                <div class="fee__cell" role="columnheader">ICI 회원</div>
                <div class="fee__cell" role="columnheader">ICI 비회원</div>
            </div>
            <!-- 데이터 -->
            <div class="fee__row" role="row">
                <div class="fee__cell" role="cell">CICP 국제공인 전문내부통제사</div>
                <div class="fee__cell fee__price" role="cell">1,000,000원</div>
                <div class="fee__cell fee__price" role="cell">1,100,000원</div>
            </div>
        </div>

        <p class="fee__footnote">
            ※ 지원자는 <strong>별도 신청서에 내부통제 경력 및 역량 기술서를 작성하여 제출</strong>해야 하며,
            <strong>국제내부통제협회(ICI) 자격인증위원회의 자격요건 심사</strong>를 거쳐 <strong>합격자에게 CICP 자격증이 발급됩니다.</strong>
        </p>
    </section>

</template>

<script setup>

</script>

<style scoped src="./Cicp.css"></style>